import { Row } from 'antd'
import styled from 'styled-components'

const StyledPaddingBottomRow = styled(Row)`
  padding-bottom: 1rem;
`

export default StyledPaddingBottomRow
